import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { EMPTY, Observable } from 'rxjs';
import { RestUrlService, TypeUrl } from './settings/rest-url.service';
import { ISingleAlphabeticalLetter } from '@interfaces';
import { catchError } from 'rxjs/operators';
@Injectable({
  providedIn: 'root'
})
export class AlphabeticalService {

  private readonly _apiUrl: string;

  constructor(
    private readonly http: HttpClient,
    private readonly restUrlService: RestUrlService
  ) {
    this._apiUrl = 'https:' + this.restUrlService.getUrl(TypeUrl.rest);
  }

  public getAlphabetical(): Observable<Array<string[]>> {
    return this.http.get<Array<string[]>>(this._apiUrl + '/api/seo/alpha').pipe(
      catchError(() => EMPTY)
    );
  }

  public getAlphabeticalByLetter(letter: string): Observable<ISingleAlphabeticalLetter[]> {
    const params: HttpParams = new HttpParams().set('letter', letter);
    return this.http.get<ISingleAlphabeticalLetter[]>(this._apiUrl + '/api/seo/alphabetical', { params }).pipe(
      catchError(() => EMPTY)
    );
  }
}
